/**
 * @generated SignedSource<<a5bcff021159d5ce9659fbe6e22c96d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleListItem_team$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleListItem_team";
};
export type EmployeeScheduleEditScheduleListItem_team$key = {
  readonly " $data"?: EmployeeScheduleEditScheduleListItem_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleListItem_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleEditScheduleListItem_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "20e303c79817bb3275ad3ef8082a1e22";

export default node;
